export function focusFirstInvalidField() {
    const first = document.querySelector<HTMLInputElement | HTMLTextAreaElement>(
        '[aria-invalid="true"], .Mui-error input, .Mui-error textarea'
    );
    if (!first || document.activeElement === first) return;
    first.focus();
    first.scrollIntoView?.({ block: "center", behavior: "smooth" });
}
